import { Mark, Class } from '@/plugins/api'
import alert from '@/plugins/alert'
import utils from '../../plugins/utils'
import { get, chunk, orderBy, keyBy } from 'lodash-es'
import moment from 'moment'

export default {
  namespaced: true,
  state: {
    marks: [],
    students: [],
    studentMarks: {},
    filterParam: {}
  },
  actions: {
    async fetchMarks({ commit }, options) {
      try {
        const classId = get(options, 'class.id')
        const classData = await Class.fetchOne(classId)
        const dateEnd = moment(options.date)
          .endOf('day')
          .toISOString()
        const dateStart = moment(options.date)
          .startOf('day')
          .toISOString()

        const length = options.subject.markType === 'mark' ? 20 : 5
        let students = classData.students.filter(s => s.status === 'active')
        students = utils.sortListByName(students)
        let studentMarks = keyBy(students, 'id')
        const groups = chunk(students, 5)
        for (let subStudents of groups) {
          await Promise.all(
            subStudents.map(async student => {
              let marks = await Mark.fetch({
                class: classId,
                subject: options.subject.id,
                factor: options.factor.id,
                semester: options.semester.id,
                student: student.id,
                _limit: -1
              })
              marks = orderBy(marks, ['date'], ['asc'])
              marks = marks.map(m => {
                return {
                  ...m,
                  rawValue: m.value,
                  markInDate: m.date === dateStart || moment(m.date).isBetween(moment(dateStart), moment(dateEnd))
                }
              })
              // khop diem, mac dinh length = 20 o cho mark, 5 o cho evaluate
              marks = Array.from(Array(length).keys()).map(
                index => marks[index] || { index, value: undefined, markInDate: true }
              )
              studentMarks[student.id] = { student, marks, factor: options.factor }
              return marks
            })
          )
        }

        commit('changeState', {
          studentMarks,
          filterParam: options
        })
      } catch (error) {
        alert.error(error)
      }
    },
    async createMark({ commit }, data) {
      try {
        const mark = await Mark.create(data)
        commit('createMark', mark)
        return mark
      } catch (e) {
        alert.error(e)
      }
    },
    async removeMark({ commit }, id) {
      await Mark.remove(id)
      commit('removeMark', id)
    },
    async updateMarks({ dispatch }, items) {
      await Promise.all(items.map(item => dispatch('updateMark', item)))
    },
    async updateMark({ commit }, { id, ...mark }) {
      const m = await Mark.update(id, mark)
      commit('updateMark', m)
    },
    setStudents({ commit }, students) {
      commit('setStudents', utils.sortListByName(students))
    },
    setFactor({ commit }, factor) {
      commit('setFactor', factor)
    }
  },
  mutations: {
    setMarks(state, marks) {
      state.marks = marks
    },
    setStudents(state, students) {
      state.students = students
    },
    setFactor(state, factor) {
      state.factor = factor
    }
  },
  getters: {
    studentMarks: state => {
      return Object.values(state.studentMarks)
    }
  }
}
